import { UNDOABLE_EVENTS } from '../atoms/label-store-dispatch/events';
import { SPAN_EDGE } from '../constants/frame-timeline-v4';
import type { ActiveDragT, SpanHandleT, SpanResizeBoundsT, SpanResizeCommitT, SpanResizePreviewT, TimelineRowDescriptorT, TrackSpanT } from '../types/frame-timeline-v4';
export function resolveSpanHandle(target: Element | null): SpanHandleT | null {
  const handle = target?.closest<HTMLElement>('[data-span-edge]');
  const cell = handle?.closest<HTMLElement>('[data-annotation-id]');
  if (!handle || !cell || cell.dataset.annotationId === undefined || cell.dataset.frame === undefined) {
    return null;
  }
  return {
    annotationId: cell.dataset.annotationId,
    isStart: handle.dataset.spanEdge === SPAN_EDGE.START,
    edgeFrame: Number(cell.dataset.frame)
  };
}
export const toPreview = (drag: ActiveDragT, frame: number): SpanResizePreviewT => ({
  annotationId: drag.annotationId,
  index: drag.index,
  isStart: drag.isStart,
  frame
});
export function applySpanResizePreview(spans: TrackSpanT[], previewSpan: SpanResizePreviewT): TrackSpanT[] {
  const {
    index,
    isStart,
    frame
  } = previewSpan;
  const span = spans[index];
  if (!span) {
    return spans;
  }
  const resized: TrackSpanT = isStart ? {
    ...span,
    start: frame
  } : {
    ...span,
    end: frame
  };
  return spans.map((currentSpan, i) => i === index ? resized : currentSpan);
}
export function appendResizePreview(rows: TimelineRowDescriptorT[], preview: SpanResizePreviewT | null): TimelineRowDescriptorT[] {
  if (!preview) return rows;
  return rows.map(row => row.id === preview.annotationId ? {
    ...row,
    spans: applySpanResizePreview(row.spans, preview)
  } : row);
}
export function resolveSpanResizeBounds(spans: TrackSpanT[], isStart: boolean, frame: number, totalFrames: number): SpanResizeBoundsT | null {
  const index = spans.findIndex(span => (isStart ? span.start : span.end) === frame);
  const span = spans[index];
  if (!span) {
    return null;
  }
  const nextStart = Math.min(totalFrames, ...spans.filter(s => s.start > span.end).map(s => s.start));
  return {
    index,
    span,
    resizableRange: [span.start, isStart ? span.end : Math.min(totalFrames - 1, nextStart - 1)]
  };
}
export function buildSpanResizeCommit(annotationId: string, span: TrackSpanT, isStart: boolean, frame: number): SpanResizeCommitT | null {
  if (isStart) {
    return frame > span.start ? {
      type: UNDOABLE_EVENTS.DELETE_ANNOTATION_FRAME_SPAN,
      annotationIdx: annotationId,
      frameSpan: {
        start: span.start,
        end: frame - 1
      },
      preserveSelection: true
    } : null;
  }
  if (frame > span.end) {
    return {
      type: UNDOABLE_EVENTS.UPDATE_ALL_ANNOTATION_FRAME_SPAN,
      annotationIdx: annotationId,
      startFrame: span.start,
      endFrame: frame
    };
  }
  if (frame < span.end) {
    return {
      type: UNDOABLE_EVENTS.DELETE_ANNOTATION_FRAME_SPAN,
      annotationIdx: annotationId,
      frameSpan: {
        start: frame + 1,
        end: span.end
      },
      preserveSelection: true
    };
  }
  return null;
}